module.exports = __webpack_public_path__ + "static/customize-346acfc48442dc51840224045ff3e15c.png";